import React from 'react'
import Link from 'gatsby-link'

import Banner from '../components/banner'
import Sectiontitle from '../components/sectionTitle'

import ActivityBlock from '../components/activityBlock'
import ActivityMap from '../components/activityMap'

const Activities = () => (
	<div>
    	<Banner type="activities" title="Activities" />
		<section className="page-grid">
			<section className="page-grid-section">
				<div className="container">
					<div className="text-center intro-div">
						<Sectiontitle title="Fun &amp; adventure starts here" />
						<br/>
					</div>
					<br/>
					<ActivityBlock />
					<br/>
					<ActivityMap />
				</div>
			</section>
		</section>
  	</div>
)

export default Activities



// WEBPACK FOOTER //
// ./src/pages/activities.js